export default defineNuxtRouteMiddleware(async (to) => {
  const userStore = useUserStore()

  // Skip middleware during server-side rendering
  if (import.meta.server) return

  // Wait for user status to resolve (avoid redirect flashes)
  if (userStore.loading) {
    await new Promise<void>((resolve) => {
      const unwatch = watch(() => userStore.loading, (isLoading) => {
        if (!isLoading) {
          unwatch()
          resolve()
        }
      })
    })
  }

  // Require authentication for all routes in /app
  if (!userStore.isLoggedIn) {
    return navigateTo(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
  }
})